export default [
  {
    path: '/admin/defines/banks',
    name: 'Banks',
    component: () => import('@/views/Admin/Defines/Banks/Index.vue'),
    meta: {
      pageTitle: 'Bankalar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/banks/add',
    name: 'BankAdd',
    component: () => import('@/views/Admin/Defines/Banks/Add.vue'),
    meta: {
      pageTitle: 'Bankalar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/banks',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/banks/edit/:id',
    name: 'BankEdit',
    component: () => import('@/views/Admin/Defines/Banks/Edit.vue'),
    meta: {
      pageTitle: 'Bankalar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/banks',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
